var map = {
	"./config.js": [
		82980
	],
	"./de_DE.js": [
		66683,
		6683
	],
	"./en_GB.js": [
		12145,
		2145
	],
	"./en_US.js": [
		81340,
		1340
	],
	"./es_ES.js": [
		63525,
		5906
	],
	"./fr_FR.js": [
		62085,
		2085
	],
	"./getLangLoader.js": [
		40627
	],
	"./index.js": [
		68000
	],
	"./it_IT.js": [
		18711,
		8711
	],
	"./ja_JP.js": [
		79816,
		9816
	],
	"./ko_KR.js": [
		40442,
		442
	],
	"./pt_BR.js": [
		28385,
		8385
	],
	"./zh_CN.js": [
		21182,
		1182
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77819;
module.exports = webpackAsyncContext;